var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaginationEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7771 12.0004L12.6391 7.8623L11.6963 8.80511L14.8915 12.0004L11.6963 15.1956L12.6391 16.1384L16.7771 12.0004ZM13.0105 12.0004L8.87249 7.8623L7.92969 8.80511L11.1249 12.0004L7.92969 15.1956L8.87249 16.1384L13.0105 12.0004Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaginationEnd);
export default __webpack_public_path__ + "static/media/icon_pagination_end.23fd495e10ab580bdaf6e050d2df0c96.svg";
export { ForwardRef as ReactComponent };